// extracted by extract-css-chunks-webpack-plugin
module.exports = {"caption":"header-item__caption--1nkqc","ico":"header-item__ico--d4AZz","bigger":"header-item__bigger--3qLZV","wrap":"header-item__wrap--1fcpa"};